import React from 'react';
import reactCSS from 'reactcss';
import { connect } from 'react-redux';
import { setSubBtnFontColor, setUnSubBtnFontColor, setSubBtnBgColor, setUnsubBtnBgColor, setHeadlineColor } from '../redux/reducer/page';
import { SketchPicker } from 'react-color';

@connect(
  state=>state.page,
  {setSubBtnFontColor, setUnSubBtnFontColor, setSubBtnBgColor, setUnsubBtnBgColor, setHeadlineColor}
)
class ColorPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false
    };
  }

  handleClick = () => {
    if (!this.props.edit) return;
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = (color) => {
    switch (this.props.unitType) {
      case "subBtnFontColor":
        this.props.setSubBtnFontColor(color.hex);
        break;
      case "unSubBtnFontColor":
        this.props.setUnSubBtnFontColor(color.hex);
        break;
      case "headlineColor":
        this.props.setHeadlineColor(color.hex);
        break;
      case "subBtnBgColor":
        this.props.setSubBtnBgColor(color.hex);
        break;
      case "unSubBtnBgColor":
        this.props.setUnsubBtnBgColor(color.hex);
        break;
      default:
        break;
    }
  };

  render() {
    const styles = reactCSS({
      'default': {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: this.props[this.props.unitType],
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
          marginTop: 4
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });
    let { unitType, kind, subBtnFontColor, unSubBtnFontColor, text } = this.props;
    return (
      <div style={{height: 32, display: 'inline-block', verticalAlign: 'bottom'}} className="color-picker">
        {
          kind === "btn" ?
            <div className="btn btn-default"
                 style={{
                   backgroundColor: this.props[unitType],
                   marginRight: 20,
                   color: `${unitType==="subBtnBgColor"?subBtnFontColor:unSubBtnFontColor}`
                 }}
                 onClick={ this.handleClick }>
              { text }
            </div>
            :
            <div style={ styles.swatch } onClick={ this.handleClick }>
              <div style={ styles.color } />
            </div>
        }
        {
          this.state.displayColorPicker &&
          <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClose }/>
            <SketchPicker color={ this.props[unitType] } onChange={ this.handleChange } />
          </div>
        }
      </div>
    )
  }
}

export default ColorPicker;


// WEBPACK FOOTER //
// ./src/container/colorPicker.js